import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource, PageEvent } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { EmploymentService } from 'src/@core/services/employment/employment.service';
import { Employment, Dates } from 'src/@core/interfaces/employment/employment.model';
import { NotificationService } from 'src/@core/services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Search } from 'src/@core/interfaces/search';
import { EmployerService } from 'src/@core/services/employer/employer.service';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { JobService } from 'src/@core/services/job/job.service';
import { JobSeeker } from 'src/@core/interfaces/job-seeker/job-seeker.model';
import { JobApplicationService } from 'src/@core/services/job/job-application.service';
import { JobApplication, JobApplicationClass } from 'src/@core/interfaces/job/job-application.model';
import { JobSeekerService } from 'src/@core/services/job-seeker/job-seeker.service';
import { EmploymentHistoryService } from 'src/@core/services/employment/employment-history.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { AppService, CURRENT_EMPLOYER } from 'src/@core/services/app.service';
import { STATUS } from 'src/app/shared/helpers/status';
import { EnterpriseAdminService } from '../../enterprise-admin/enterprise-admin.service';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { ViewActivationImageComponent } from '../../dashboard/view-activation-image/view-activation-image.component';
import { AddActivationImageComponent } from '../../dashboard/add-activation-image/add-activation-image.component';
import { ViewUploadedImageComponent } from './view-uploaded-image/view-uploaded-image.component';
import { AddEditTaskComponent } from './add-edit-task/add-edit-task.component';
import { DeleteEvent } from 'src/@core/interfaces/delete-event';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/components/confirm-delete-dialog/confirm-delete-dialog.component';
import { EmploymentMapViewComponent } from '../active-employments/employment-map-view/employment-map-view.component';

@Component({
  selector: 'hour4u-admin-view-proof-of-work',
  templateUrl: './view-proof-of-work.component.html',
  styleUrls: ['./view-proof-of-work.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
})
export class ViewProofOfWorkComponent implements OnInit {
  loadComponent: boolean = false;
  employment: any = null;
  searchParams: Array<Search> = [];
  jobSeekers = Array<JobSeeker>();
  jobApplications: JobApplication[];
  jobApplicationPage: JobApplication[];
  activeDate: any;
  roles = roles;
  entityTypes = entityTypes;
  paramDate;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(EmploymentMapViewComponent, { static: false }) employmentMapView?: EmploymentMapViewComponent;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  resultsLength = 0;
  pageIndex = 0;
  copiedEmployer: boolean = false;
  copyTitleEmployer: string = 'Copy link to share';
  showNoAccessState: boolean = false;
  status = STATUS;
  routeData: any = null;
  selectedJobSeekerDetails: any = null;
  workImages: any[] = [];
  tableWorkImages: MatTableDataSource<any>
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  selectedView: boolean = false;
  displayedColumns: any[] = [];
  columns: any[] = [];
  baseImageUrl = environment.image_url;
  batchIndex: number = 0;
  forAll: any = null;
  clickedOnStatusChange: boolean = false;
  isLoading: boolean = false;
  loadApplications: boolean = false;
  profile = this.appService.getCurrentAccount();
  showAllMarkers: boolean;
  isMarkerLoading: boolean = false;

  constructor(private route: ActivatedRoute,
    private employmentService: EmploymentService,
    private notify: NotificationService,
    private employerService: EmployerService,
    private jobService: JobService,
    private jobTypeService: JobTypeService,
    private jobApplicationService: JobApplicationService,
    private jobSeekerService: JobSeekerService,
    private employmentHistoryService: EmploymentHistoryService,
    private dialog: MatDialog,
    private router: Router,
    public enterpriseAdminService: EnterpriseAdminService,
    private cdRef: ChangeDetectorRef,
    private appService: AppService
  ) {

  }

  ngOnInit() {
    this.paramDate = this.route.snapshot.paramMap.get('date');
    this.forAll = this.route.snapshot.paramMap.get('for');
    console.log(this.forAll);
    document.getElementById('detail-header').style.display = 'none';

    this.route.params.subscribe(async data => {
      this.routeData = data;
      await this.loadEmploymentData(data.id);
      console.log("asdasdasd", data)
      this.searchParams.push(new Search('employmentId', data.id));
      this.searchParams.push(new Search('seekerId', data.seekerId));
    });

    this.checkQueryParam();
  }

  checkQueryParam() {
    console.log("this.loadComponent", this.loadComponent)

    this.route.queryParams.subscribe(params => {
      const viewValue = params['view'];

      console.log("viewValue", viewValue)

      if (viewValue === 'table') {
        this.loadComponent = true;
      } else if (viewValue === 'map') {
        this.loadComponent = false;
      }
    });

    console.log("this.loadComponent", this.loadComponent)
  }

  loadMap() {

    this.loadComponent = false;

    // Update the query parameter to 'view=map'
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: { view: 'map' },
    //   queryParamsHandling: 'merge',
    //   replaceUrl: true
    // });

    // // Reload the page
    // window.location.reload();

  }

  loadList() {
    this.loadComponent = true;
    console.log("this.loadComponent", this.loadComponent)
  }

  async loadEmploymentData(id: string) {
    await this.enterpriseAdminService.getWorkOrderById(id).toPromise()
      .then(data => {
        console.log(data)
        this.employment = data;
        this.employment.id = this.employment.workOrder.id;
        // fetch active date
        // finding active date to view active employment
        this.activeDate = this.employment.workOrder.dates.find(x => x.isActive)

        // if user is view past employment
        // date will come along with navigation params
        // and active date will be replaced with requested date
        if (this.paramDate) {
          this.activeDate = this.employment.workOrder.dates.find(x => x.date == this.route.snapshot.paramMap.get('date'))
        }
      }).catch(error => {
        this.notify.showMessage('Could not load employment data...', 2000);
      }).finally(async () => {
        // load employer
        // await this.employerService.getById(this.employment.employerId).toPromise()
        //   .then(data => {
        //     this.employment.employer = data;
        this.showNoAccessState = false;
        //     if (this.employment && JSON.parse(localStorage.getItem(CURRENT_EMPLOYER))) {
        //       if (this.employment.employerId != JSON.parse(localStorage.getItem(CURRENT_EMPLOYER)).id) {
        //         document.getElementById('detail-header').style.display = 'none';
        //         this.showNoAccessState = true;
        //       } else {
        //         document.getElementById('detail-header').style.display = 'block';
        //         this.loadJob(this.employment.id);
        //         this.loadJobApplications();
        //       }
        //     } else {
        document.getElementById('detail-header').style.display = 'block';
        this.loadJob(this.employment.id);
        // }
        // });
      });
  }

  async loadJob(employmentId) {
    // load job
    await this.jobService.getById(this.employment.workOrder.jobId).toPromise()
      .then(job => {
        this.employment.job = job;
      }).finally(async () => {
        await this.jobTypeService.getById(this.employment.job.jobTypeId).toPromise()
          .then(jobType => {
            this.employment.job.jobType = jobType;

            if (!this.employment.job.manpowerTrackingRequired) {
              this.employementHistory();
            } else {
              this.loadJobApplications();
            }
          });
      })
  }

  employementHistory() {
    this.jobApplications = [];
    this.enterpriseAdminService.getEmployemnetHistory(this.employment.workOrder.id).toPromise()
      .then(async (data) => {
        console.log(data)
        this.workImages = [];
        if (data.content && data.content.length) {
          data.content.forEach((el, index) => {
            if (el.imageProofs) {
              console.log(el.imageProofs)
              let workImages = el.imageProofs.filter(ip => ip.proofEnum == 'MIDDLE');
              if (workImages.length) {
                let isImageField = workImages[0].workProofs.filter((ip: any) => ip.fieldType === 'file')
                console.log("$$$$$$$$$$$", isImageField)
                let isFileFieldAvailable = false;
                if (isImageField && !isImageField.length) {
                  isFileFieldAvailable = false;
                } else {
                  isFileFieldAvailable = true;
                }
                console.log(workImages)
                workImages.forEach((el: any) => {
                  el.tempJobSeeker = "";
                  el.tempJobSeekerName = "";
                  el.tempJobSeekerMobile = "";
                  el.tempJobSeekerId = "";
                  el.jobSeekerId = "";
                  el.isFileFieldAvailable = isFileFieldAvailable;
                  // if (this.jobApplications[0].history && this.jobApplications[0].history.id)
                  el.employmentHistoryId = el.id;
                  this.workImages.push(el)
                })
              }
            }
            // }
            // }
            // }
            if (this.workImages && this.workImages.length) {
              this.workImages.forEach(ele => {
                if (ele && ele.dateTime && ele.dateTime.length) {
                  ele.datee = new Date(ele.dateTime[0] + "-" + ele.dateTime[1] + "-" + ele.dateTime[2])
                  ele.time = [ele.dateTime[3], ele.dateTime[4]];
                }
                ele.workProofs.forEach(element => {
                  if (element.fieldName == "") {
                    element.fieldName = "-"
                  }
                  if (element.fieldLabel == "") {
                    element.fieldLabel = "-"
                  }
                  ele[element['fieldName']] = element['fieldValue'];
                });
              })
            }
            console.log(this.workImages)

            // Sort the list based on the dateTime field
            this.workImages.sort((a, b) => {
              const dateA = new Date(a.dateTime[0], a.dateTime[1] - 1, a.dateTime[2], a.dateTime[3], a.dateTime[4], a.dateTime[5]);
              const dateB = new Date(b.dateTime[0], b.dateTime[1] - 1, b.dateTime[2], b.dateTime[3], b.dateTime[4], b.dateTime[5]);
              return dateA.getTime() - dateB.getTime();
            });

            this.workImages = this.workImages.reverse();
            this.tableWorkImages = new MatTableDataSource(this.workImages);
            console.log(this.tableWorkImages.data)
            console.log("jobApplications=", this.jobApplications)
            this.cdRef.detectChanges();
            this.columnDefined();
            this.loadList();
            // if (index == this.resultsLength - 1) {
            this.loadApplications = true;
            this.isLoading = false;
            // }
          });
        } else {
          this.isLoading = false;
        }
      });
  }

  async loadJobApplications() {
    this.isLoading = true;
    this.jobApplications = [];
    this.tableWorkImages = new MatTableDataSource();
    // this.notify.showMessage('Loading applicants .....', 2000);
    console.log(" this.employment===========", this.employment)
    const serachParams = [new Search('employmentId', this.employment.id)];
    serachParams.push(new Search('status', 'COMPLETED'));
    serachParams.push(new Search('status', 'APPROVED'));
    serachParams.push(new Search('employmentId', this.employment.workOrder.id));
    this.loadApplications = false;
    await this.jobApplicationService.searchAndSort(0, 5000, null, null, serachParams).toPromise()
      .then(data => {
        if (data.content.length > 0) {
          this.jobApplications = data.content;
          this.resultsLength = this.jobApplications.length;
          console.log("js", this.jobApplications);
          this.jobApplications.forEach((ja, index) => {
            // laod js
            this.jobSeekerService.getById(ja.jobSeekerId).toPromise()
              .then((js) => {
                ja.tempJobSeeker = js;
                // load history
                this.employmentHistoryService.searchAndSort(0, 1000, null, null, [new Search('employmentId', this.employment.workOrder.id), new Search('jobSeekerId', ja.jobSeekerId)]).toPromise()
                  .then(async (data) => {
                    console.log(data)
                    this.workImages = [];
                    if (data.content && data.content.length) {
                      data.content.forEach(el => {
                        ja.history = el;

                        this.jobApplicationPage = this.jobApplications.slice(0, this.pageSize);
                        for (let i = 0; i < this.jobApplicationPage.length; i++) {
                          let ele = this.jobApplicationPage[i];
                          if (this.routeData && this.routeData.seekerId) {
                            if (ele.jobSeekerId == this.routeData.seekerId) {
                              this.selectedJobSeekerDetails = ele;
                              if (this.selectedJobSeekerDetails.history && this.selectedJobSeekerDetails.history.imageProofs && this.selectedJobSeekerDetails.history.imageProofs.length) {
                                this.workImages = this.selectedJobSeekerDetails.history.imageProofs.filter(ip => ip.proofEnum == 'MIDDLE');
                                if (this.workImages && this.workImages.length) {
                                  let isImageField = this.workImages[0].workProofs.filter((ip: any) => ip.fieldType === 'file')
                                  console.log("$$$$$$$$$$$", isImageField)
                                  let isFileFieldAvailable = false;
                                  if (isImageField && !isImageField.length) {
                                    isFileFieldAvailable = false;
                                  } else {
                                    isFileFieldAvailable = true;
                                  }
                                  this.workImages.forEach((el: any) => {
                                    el.tempJobSeeker = ele;
                                    el.tempJobSeekerName = ele.tempJobSeeker.name;
                                    el.tempJobSeekerMobile = ele.tempJobSeeker.mobile;
                                    el.tempJobSeekerId = ele.tempJobSeeker.entityId;
                                    el.jobSeekerId = ele.tempJobSeeker.id;
                                    el.isFileFieldAvailable = isFileFieldAvailable;
                                    if (ja.history && ja.history.id)
                                      el.employmentHistoryId = ja.history.id;
                                  })
                                }
                              }
                            }
                          } else {
                            if (ele.history) {
                              let prrof = JSON.parse(JSON.stringify(ele.history))
                              if (prrof.imageProofs) {
                                console.log(prrof.imageProofs)
                                let workImages = prrof.imageProofs.filter(ip => ip.proofEnum == 'MIDDLE');
                                if (workImages.length) {
                                  let isImageField = workImages[0].workProofs.filter((ip: any) => ip.fieldType === 'file')
                                  console.log("$$$$$$$$$$$", isImageField)
                                  let isFileFieldAvailable = false;
                                  if (isImageField && !isImageField.length) {
                                    isFileFieldAvailable = false;
                                  } else {
                                    isFileFieldAvailable = true;
                                  }
                                  console.log(workImages)
                                  workImages.forEach((el: any) => {
                                    el.tempJobSeeker = ele;
                                    el.tempJobSeekerName = ele.tempJobSeeker.name;
                                    el.tempJobSeekerMobile = ele.tempJobSeeker.mobile;
                                    el.tempJobSeekerId = ele.tempJobSeeker.entityId;
                                    el.jobSeekerId = ele.tempJobSeeker.id;
                                    el.isFileFieldAvailable = isFileFieldAvailable;
                                    if (ja.history && ja.history.id)
                                      el.employmentHistoryId = ja.history.id;
                                    this.workImages.push(el)
                                  })
                                }
                              }
                            }
                          }
                        }
                        if (this.workImages && this.workImages.length) {
                          this.workImages.forEach(ele => {
                            if (ele && ele.dateTime && ele.dateTime.length) {
                              ele.datee = new Date(ele.dateTime[0] + "-" + ele.dateTime[1] + "-" + ele.dateTime[2])
                              ele.time = [ele.dateTime[3], ele.dateTime[4]];
                            }
                            ele.workProofs.forEach(element => {
                              if (element.fieldName == "") {
                                element.fieldName = "-"
                              }
                              if (element.fieldLabel == "") {
                                element.fieldLabel = "-"
                              }
                              ele[element['fieldName']] = element['fieldValue'];
                            });
                          })
                        }
                        console.log(this.workImages)

                        // Sort the list based on the dateTime field
                        this.workImages.sort((a, b) => {
                          const dateA = new Date(a.dateTime[0], a.dateTime[1] - 1, a.dateTime[2], a.dateTime[3], a.dateTime[4], a.dateTime[5]);
                          const dateB = new Date(b.dateTime[0], b.dateTime[1] - 1, b.dateTime[2], b.dateTime[3], b.dateTime[4], b.dateTime[5]);
                          return dateA.getTime() - dateB.getTime();
                        });

                        this.workImages = this.workImages.reverse();
                        this.tableWorkImages = new MatTableDataSource(this.workImages);
                        console.log(this.tableWorkImages.data)
                        console.log("jobApplications=", this.jobApplications)
                        this.cdRef.detectChanges();
                        this.columnDefined();
                        this.loadList();
                        if (index == this.resultsLength - 1) {
                          this.loadApplications = true;
                          this.isLoading = false;
                          this.loadMap();
                        }
                      });
                    } else {
                      this.isLoading = false;
                    }
                  });
              });

          });
        } else {
          this.isLoading = false;
        }
      }).catch(err => {
        this.isLoading = false;
      })
  }

  columnDefined() {
    this.columns = [];
    if (this.workImages && this.workImages.length) {
      console.log("this.workImages=======", this.workImages)
      if (this.workImages[0].workProofs && this.workImages[0].workProofs.length) {
        if (this.workImages[0].workProofs.length) {
          this.workImages[0].workProofs.forEach((element, index) => {
            if (element.fieldName == "") {
              element.fieldName = "-"
            }
            if (element.fieldLabel == "") {
              element.fieldLabel = "-"
            }
            if (element.fieldName != "" && element.fieldLabel != "") {
              if (element.fieldType != 'file') {
                this.columns.push({ columnDef: element.fieldName, label: element.fieldLabel })
              } else {
                let label = element.fieldLabel;
                if (!label.toLowerCase().includes('image')) {
                  label = element.fieldLabel + ' Image';
                }
                // element.fieldName = element.fieldName + '_' + index
                this.columns.push({ columnDef: element.fieldName, label: label })
                // this.columns.push({ columnDef: element.fieldName + '_' + index, label: label })
              }
            }
          });
          let isImageField = this.workImages[0].workProofs.filter((ip: any) => ip.fieldType === 'file')
          if (isImageField && !isImageField.length) {
            this.columns.push({ columnDef: 'imagePath', label: 'Image' })
          }
        }
      } else {
        if (this.workImages[0] && this.workImages[0].imagePath) {
          this.columns.push({ columnDef: 'imagePath', label: 'Image' })
        }
      }
      this.columns.push({ columnDef: 'dateTime', label: 'Task added on' })

      if (this.forAll) {
        this.columns.push({ columnDef: 'tempJobSeekerName', label: 'Job Seeker Name' })
        this.columns.push({ columnDef: 'tempJobSeekerMobile', label: 'Job Seeker Mobile No.' })
      }
      this.columns.push({ columnDef: 'status', label: 'Task Status' })
      this.columns.push({ columnDef: 'action', label: '' })
    }
    console.log(this.columns)
    this.displayedColumns = [...this.columns.map(x => x.columnDef)];
  }

  getPageData(e: PageEvent) {
    this.jobApplicationPage = this.jobApplications.slice(e.pageIndex * e.pageSize, (e.pageIndex + 1) * e.pageSize);
  }

  copyLinkToClipboardForEmployer() {
    let copyUrl = null;
    this.copiedEmployer = true;
    this.copyTitleEmployer = 'Copied to your clipboard!';

    if (environment.api_url == 'https://devapi.hour4u.com') {
      copyUrl = 'https://dev.workorbits.com' + this.router.url
    }
    if (environment.api_url == 'https://api.hour4u.com') {
      copyUrl = 'https://workorbits.com' + this.router.url
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.notify.showMessage('Link copied!', 3000)
    setTimeout(() => {
      this.copiedEmployer = false;
      this.copyTitleEmployer = 'Copy link to share';
    }, 7000);
  }

  dataRefresh() {
    this.router.navigateByUrl('/employment/all/all');
  }

  viewUploadedImage(element: any, column: any) {
    console.log("$$$$$$$$$$$$$", element, column)
    let imagePath = "";
    if (column == 'imagePath') {
      imagePath = this.baseImageUrl + element.imagePath;
    } else {
      element.workProofs.forEach(ele => {
        if (ele.fieldName == column) {
          imagePath = ele.fieldValue;
        }
      });
    }

    if (imagePath) {
      const dialogRef = this.dialog.open(ViewUploadedImageComponent, {
        width: '1024px',
        panelClass: 'add-edit-user-dialog',
        disableClose: true,
        data: {
          imageUrl: imagePath,
          selectedTask: element,
          title: 'View Task Image'
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (!this.employment.job.manpowerTrackingRequired) {
            this.employementHistory();
          } else {
            this.loadJobApplications();
          }
        }
      });
    } else {
      console.error('Image URL not available.');
    }
  }

  addEditTasks(selectedData?: any, multiTaskUpload: boolean = false) {
    console.log(selectedData)
    if (selectedData) {
      if (!this.selectedJobSeekerDetails) {
        if (this.jobApplicationPage && this.jobApplicationPage.length) {
          for (let i = 0; i < this.jobApplicationPage.length; i++) {
            let ele = this.jobApplicationPage[i];
            if (ele.jobSeekerId == selectedData.jobSeekerId) {
              this.selectedJobSeekerDetails = ele;
            }
          }
        }
      }
    }
    let isFileFieldAvailable = false;
    if (!selectedData) {
      let workProofs = [];
      console.log(this.jobApplications)
      if (this.jobApplications && this.jobApplications.length) {
        this.jobApplications[0].proofOfWork.proofOfWorkFields.forEach(element => {
          let obj = {
            fieldLabel: element.requiredInfoFieldLabel,
            fieldName: element.requiredInfoFieldName,
            fieldValue: "",
            fieldType: element.requiredInfoFieldType,
            displayFieldType: element.requiredDisplayFieldType
          }
          workProofs.push(obj);
        });
        let isImageField = this.jobApplications[0].proofOfWork.proofOfWorkFields.filter((ip: any) => ip.requiredInfoFieldType === 'file')
        if (isImageField && !isImageField.length) {
          isFileFieldAvailable = false;
        } else {
          isFileFieldAvailable = true;
        }
      } else {
        if (this.employment && this.employment.job && this.employment.job.deliverables && this.employment.job.deliverables.length) {
          let obj = {
            fieldLabel: this.employment.job.deliverables[0].fieldLabel,
            fieldName: this.employment.job.deliverables[0].fieldName,
            fieldValue: "",
            fieldType: this.employment.job.deliverables[0].fieldType,
            displayFieldType: this.employment.job.deliverables[0].displayFieldType
          }
          workProofs.push(obj);

          let isImageField = workProofs.filter((ip: any) => ip.requiredInfoFieldType === 'file')
          if (isImageField && !isImageField.length) {
            isFileFieldAvailable = false;
          } else {
            isFileFieldAvailable = true;
          }
        }
      }
      selectedData = {};
      selectedData.label = 'Add';
      selectedData.imagePath = "";
      selectedData.workProofs = workProofs;
      selectedData.isFileFieldAvailable = isFileFieldAvailable;
    } else {
      selectedData.label = 'Edit';
    }

    if (multiTaskUpload) {
      selectedData.label = 'Upload tasks';
      selectedData.multiTaskUpload = multiTaskUpload;
    }
    selectedData.employmentId = this.employment.workOrder.id;
    selectedData.champsList = this.jobApplications;
    selectedData.forAll = this.forAll;
    let obj = {
      selectedTask: selectedData,
      selectedJobSeeker: this.selectedJobSeekerDetails,
      selectedProject: this.employment.job
    }
    const dialogRef = this.dialog.open(AddEditTaskComponent, {
      width: '500px',
      data: obj,
      panelClass: 'add-edit-venue-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.employment.job.manpowerTrackingRequired) {
          this.employementHistory();
        } else {
          this.loadJobApplications();
        }
      }
    });
  }

  viewCard() {
    this.selectedView = true;
    this.loadComponent = true;
  }

  viewTable() {
    this.selectedView = false;
    this.loadComponent = true;
  }

  onFileSelected(event: any) {
    console.log(event)
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      console.log(file)
      if (file && file.type.startsWith('image/')) {
        this.displayThumbnail(file);
        this.compressAndUpload(file);
      }
    }
    this.batchIndex++;
  }

  displayThumbnail(file: File) {
    const thumbnailContainer = document.querySelector('.image-thumbnails');
    if (thumbnailContainer) {
      const thumbnailDiv = document.createElement('div');
      thumbnailDiv.className = 'image-thumbnail';

      const uploadingTextDiv = document.createElement('div');
      uploadingTextDiv.className = 'uploading-text';
      //uploadingTextDiv.textContent = 'Uploading...';

      const image = document.createElement('img');
      image.src = URL.createObjectURL(file);
      image.alt = 'Thumbnail';
      image.style.width = '84px';
      image.style.height = '84px';
      image.style.objectFit = 'cover';
      image.style.borderRadius = '12px';
      thumbnailDiv.appendChild(uploadingTextDiv);
      thumbnailDiv.appendChild(image);

      thumbnailContainer.appendChild(thumbnailDiv);
    }
  }

  compressAndUpload(file: File) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const maxWidth = 1800;
    const maxHeight = 1800;
    const image = new Image();
    const uploadingTextDiv = this.createUploadingTextElement();

    image.onload = () => {
      let width = image.width;
      let height = image.height;

      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width *= ratio;
        height *= ratio;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(image, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          const compressedFile = new File([blob], file.name, { type: 'image/jpeg' });
          this.enterpriseAdminService.UploadAttendancePicture(this.selectedJobSeekerDetails.jobSeekerId, compressedFile, this.batchIndex).subscribe(
            (response: any) => {
              console.log('S3 Upload Success:', response);
              // this.selectedImages.push(response.key);
              // const selectedIndex = this.selectedImages.indexOf(response.key);
              // console.log(this.data.selectedTask)
              // this.data.selectedTask.imagePath = response.key;
              // Remove the uploading text after receiving a response from S3
              uploadingTextDiv.remove();
              if (!this.employment.job.manpowerTrackingRequired) {
                this.employementHistory();
              } else {
                this.loadJobApplications();
              }
            },
            (error) => {
              console.error('Error uploading image to S3:', error);

              // Remove the uploading text in case of an error
              uploadingTextDiv.remove();
            }
          );
        },
        'image/jpeg',
        0.6
      );
    };

    image.src = URL.createObjectURL(file);
  }

  createUploadingTextElement(): HTMLElement {
    const uploadingTextDiv = document.createElement('div');
    uploadingTextDiv.className = 'uploading-text';
    uploadingTextDiv.textContent = 'Uploading...';

    const thumbnailContainer = document.querySelector('.image-thumbnails');
    if (thumbnailContainer) {
      thumbnailContainer.appendChild(uploadingTextDiv);
    }

    return uploadingTextDiv;
  }

  // approve Reject Task
  approveRejectTask(data, status) {
    this.isLoading = true;
    console.log(data, status)
    let param = {
      id: data.id,
      employmentHistoryId: data.employmentHistoryId,
      imageProfPath: data.imagePath,
      updatedStatus: status,
    }
    this.enterpriseAdminService.updateTaskStatus(param).subscribe(async (res) => {
      this.notify.showMessage("Work Order status updated Successfully!", 2000);
      this.refreshPage();
    }, (err => {
      this.isLoading = false;
      this.notify.showMessage("Work Order status update failed!", 2000);
    }))
  }

  // delete Task
  deleteTask(row) {
    const data = new DeleteEvent();
    data.setId(row.jobSeekerId);
    data.setName(row.tempJobSeekerName);
    data.setType('Proof Of Work');
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      data
    });

    dialogRef.afterClosed().subscribe(code => {
      if (code) {
        this.deleteImage(row);
      }
    });
  }

  // delete attendance Image
  async deleteImage(data: any) {
    let param = {
      id: data.id,
      previousImagePath: data.imagePath,
      workOrderId: this.employment.workOrder.id,
      jobSeekerId: data.jobSeekerId,
      proofEnum: data.proofEnum,
      description: data.description
    }
    this.enterpriseAdminService.DeleteAttendanceImgProof(param).subscribe(async (res) => {
      this.notify.showMessage("Work Picture deleted Successfully!", 2000);
      if (!this.employment.job.manpowerTrackingRequired) {
        this.employementHistory();
      } else {
        this.loadJobApplications();
      }
    }, (err => {
      this.notify.showMessage("Work Picture deleted failed!", 2000);
    }))
  }

  // refresh Page
  refreshPage() {
    if (!this.employment.job.manpowerTrackingRequired) {
      this.employementHistory();
    } else {
      this.loadJobApplications();
    }
  }

  prepareBills(isView) {
    console.log(this.employment)
    let obj = Object.assign({}, this.employment.project);
    obj.isView = isView;
    obj.billingTitle = this.employment.workOrder.workOrderTitle ? this.employment.workOrder.workOrderTitle : this.employment.workOrder.venue.name;
    obj.selectedWorkOrders = [];
    obj.selectedWorkOrders.push(this.employment.workOrder);

    let entityId = "";
    if (this.profile.entity.entityType === 'AGENCY') {
      entityId = '&createdByEntityId=' + this.profile.entity.id;
    }

    if (this.profile.entity.entityType === 'ENTERPRISE') {
      entityId = '&paidByEntityId=' + this.profile.entity.id;
    }
    this.jobService.fetchBillDetailsByWorkorderId(this.employment.project.id, entityId, this.employment.workOrder.id).subscribe(res => {
      console.log(res)
      obj.billingData = res && res.length ? res[0] : null;
      this.jobService.saveBillingData(obj);
      this.router.navigateByUrl("/job/create-bill/" + this.employment.project.id);
    });

  }

  goToMapView(lat, lng) {
    if (lat && lng) {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank');
    }
  }

  showAllTaskMarkers() {
    this.showAllMarkers = true;
    this.cdRef.detectChanges();
  }
  triggerShowAllTaskMarkers(): void {

    this.isMarkerLoading = true;
    if (this.employmentMapView) {
      console.log("cathis.employmentMapViewlled", this.employmentMapView)
      this.employmentMapView.showAllTaskMarkers();
      this.isMarkerLoading = false;
    }
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
    console.log('Employment Map View Component:', this.employmentMapView);
  }

  reloadMapData() {
    console.log("reloadMapData called");
    this.ngOnInit();
  }
}
